<script setup lang="ts">
import Button from '@components/Button.vue';
</script>

<template>
  <Button
    variant="white"
    :class="[
      '!p-0',
      '!size-12 lg:!size-10',
      '!flex items-center justify-center',
    ]"
  >
    <slot />
  </Button>
</template>
